export const NOTICE_TYPES = {
  ANNOUNCEMENT: "ANNOUNCEMENT",
  NOTIFICATION: "NOTIFICATION"
};

export const ANNOUNCEMENT_LINK_TYPES = {
  INTERNAL: 1,
  EXTERNAL: 2
};

export const NOTIFICATION_TYPES = {
  SEND_PETTY_CASH: 211, // سوال سوییچ به پنل مدیریتی
  REQUEST_RETURN_PETTY_CASH: 212, // پنل مدیریتی
  REJECT_PETTY_CASH: 213, // پنل مدیریتی
  APPROVE_PETTY_CASH: 214, // پنل مدیر
  RETURN_PETTY_CASH: 215 // پنل تنخواه فک کنم
};

export const ACTION_TYPE = {
  READ: 1,
  UNREAD: 2,
  DELETE: 3
};
